const TabDescription = ({ children }) => (
  <p
    style={{
      marginTop: 10,
      color: '#13174f',
      fontSize: 14,
      fontWeight: 'bold',
    }}
  >
    {children}
  </p>
)

export default TabDescription
